<template>
  <div>
    <adv-button
      v-if="!isVariationGroupMaster"
      class="quickViewBtn"
      :is-listing="isListing"
      :is-variation-group-master="isVariationGroupMaster"
      :productId="this.productId"
      v-on:btn-click="toggleQuickView"
      v-show="showQuickView"
    >
      <i class="fas fa-eye"></i>
    </adv-button>

    <adv-button
      v-if="hasAttributes || hasCustomization"
      :class="buttonBuyClass"
      :is-listing="isListing"
      :is-variation-group-master="isVariationGroupMaster"
      :productId="this.productId"
      :attribute-ids-with-stock="getAttributeIdsWithStock"
      :disabled="setDisabled || cartLimitForProductReached"
      v-on:btn-click="toggleQuickView"
      v-show="showAddToCart"
      v-html="buttonBuyText"
    >
    </adv-button>

    <adv-cart-button
      v-else
      v-show="showAddToCart"
      :is-listing="isListing"
      :is-variation-group-master="isVariationGroupMaster"
      :class="buttonBuyClass"
      :quantity="quantity"
      :stock="stock"
      :productId="this.productId"
      :progress="progress"
      :cart-limit-reached="cartLimitForProductReached"
      :disabled="setDisabled || cartLimitForProductReached"
      v-on:btn-click="btnBuyClicked"
      v-on:btn-click-no-stock="btnBuyClickedNoStock"
      v-on:btn-click-variation-master="btnBuyClickedForVariationMaster"
    >
    </adv-cart-button>
  </div>
</template>

<script>
import store from '../../vue/store'
import productMixin from './mixins/productMixins'
import onlineMixin from './mixins/onlineMixin'
import cartButtonMixin from './mixins/cartButtonMixin'
import AdvButton from './presentation/AdvButton'
import AdvCartButton from './AdvCartButton'
import { flatten, some } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AdvButtonViewBuy',
  mixins: [productMixin, onlineMixin, cartButtonMixin],
  props: {
    productId: {
      type: Number,
      default: null
    },
    showImage: {
      type: Boolean,
      default: true
    },
    showName: {
      type: Boolean,
      default: true
    },
    showContent: {
      type: Boolean,
      default: true
    },
    showQuickView: {
      type: Boolean,
      default: false
    },
    showAddToCart: {
      type: Boolean,
      default: true
    },
    isListing: {
      type: Boolean,
      default: false
    },
    isVariationGroupMaster: {
      type: Boolean,
      default: false
    },
    recommendationType: {
      type: String,
      default: null
    },
    recommendationId: {
      type: String,
      default: null
    }
  },
  components: {
    AdvCartButton,
    AdvButton
  },
  data () {
    return {
      version: '0.0.1',
      quickViewVisible: false,
      progress: false
    }
  },
  computed: {
    ...mapGetters([
      'cartProductCodeQuantity',
      'productCardModal'
    ]),
    ...mapGetters('cartProductCustomizations', ['getSchemaById']),
    setDisabled () {
      if (this.isListing && this.isVariationGroupMaster) {
        return false
      }
      return this.stock <= 0 || !this.onlineStatus
    },
    quantity () {
      return this.cartProductCodeQuantity(this.productData.productCodes[0].productCodeId)
    },
    cartQuantity () {
      return this.cartProductCodeQuantity(this.productCodeId, 0)
    },
    cartLimitForProductReached () {
      if (this.isListing && this.isVariationGroupMaster) {
        return false
      }
      return this.stock === this.quantity - 1
    },
    hasAttributes () {
      return some(this.productData.productCodes, (e) => {
        return e.productCodeAttributes.length > 0
      })
    },
    hasCustomization () {
      return ('customizationSchemaId' in this.productData) &&
        this.productData.customizationSchemaId !== null &&
        this.getSchemaById(this.productData.customizationSchemaId).is_active
    },
    quickViewButtonVisible () {
      return this.productCardModal.open
    },
    stock () {
      return this.productData.productStock
    },
    buttonBuyText () {
      if (this.stock <= 0) {
        return this.t('product_status.unavailable.coming_soon')
      }

      return `<i class="ti-shopping-cart"></i> ${this.t('add_to_cart')}`
    },
    buttonBuyClass () {
      if (this.stock > 0) {
        return 'addtoCart';
      }

      return 'addtoCart unavailable';
    },
    getAttributeIdsWithStock () {
      return flatten(this.productData.productCodes
        .filter(item => item.productStock > 0)
        .map(item => item.productCodeAttributes))
    }
  },
  methods: {
    ...mapActions([
      'addToCartClicked',
      'openProductCardModal',
      'closeProductCardModal'
    ]),
    toggleQuickView () {
      if (
        this.productData.productCodes.length === 1 &&
        this.productData.productCodes[0].productCodeAttributes.length === 1 &&
        !this.hasCustomization
      ) {
        this.btnBuyClicked()
        return
      }
      if (this.productCardModal.open) {
        this.closeProductCardModal()
      } else {
        this.openProductCardModal(this.productId)
      }
    },
    btnBuyClicked () {
      this.progress = true
      this.addToCartClicked({
        productCodeId: this.productData.productCodes[0].productCodeId,
        quantity: this.quantity,
        recommendationType: this.recommendationType,
        recommendationId: this.recommendationId
      })
        .then(() => {
          this.progress = false
        })
    },
    btnBuyClickedNoStock () {
      // for clients that need click event without stock on button
    },
    /**
     * This is a special case for variation group master products.
     * If the product is a variation group master,
     * and we are in a listing page, we need to redirect to the product's page.
     */
    btnBuyClickedForVariationMaster () {
      // old comment below fwiw:
      // for variations: if isListing && isVariationGroupMaster emits btn-click-no-stock so here we are
      if (this.isListing && this.isVariationGroupMaster) {
        window.location.href = this.productData.productUrl
      }
    }
  }
}
</script>
